import request from '@/utils/request'

let QuickserviceApi = {

  /*快捷服务列表*/
  list(data) {
    return request._post('/shop/plus.quickservice.Index/index', data);
},
/*添加快捷服务*/
add(data) {
    return request._post('/shop/plus.quickservice.Index/add', data);
},
/*修改快捷服务*/
edit(data) {
    return request._post('/shop/plus.quickservice.Index/edit', data);
},
/*删除快捷服务*/
del(data) {
    return request._post('/shop/plus.quickservice.Index/del', data);
},
/*快捷服务详情*/
detail(data) {
  return request._post('/shop/plus.quickservice.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.quickservice.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.quickservice.Setting/getSetting', data, errorback);
    },
}
export default QuickserviceApi;



// WEBPACK FOOTER //
// ./src/api/quickservice.js